<template>
	<div class="query-button-component">
<!-- WITH DROPDOWN -->
		<div class="drop-div" v-if="enableDropDown" v-bind:class="{noHover: disable}">
			<div>
				<button
					class="button"
					v-text="buttonText"
					:disabled="disable"
					@click="drop = !drop"
				/>
			</div>
			<div class="drop-list"
				v-if="drop"
			>
				<button class="button"
					v-for="(q) in this.queries"
					v-bind:key="q.RootInstance.ID"
					v-bind:class="{noHover: disable}"
					v-text="q.iBranches[0].Parent.value"
					:disabled="(q.RootInstance.isPinned && queryMode== 1) || disable"
					v-on:click="querySelect(q)"
				/>
			</div>
		</div>

<!-- WITHOUT DROPDOWN -->
	<div class="row-div" v-if="!enableDropDown">
		<button
			class="button"
			v-for="(q) in queries"
			v-bind:class="{
				noHover: disable,
				selected: q.ID == activeQuery?.ID || q.RootInstance?.ID == activeQuery?.RootInstance?.ID,
				stale: (q.ID == activeQuery?.ID || q.RootInstance?.ID == activeQuery?.RootInstance?.ID) && staleFilters
			}"
			v-bind:key="q.ID"
			v-text="q.RootInstance.value + suffix"
			:disabled="(q.RootInstance.isPinned && queryMode== 2) || disable"
			v-on:click="querySelect(q)"
		/>
	</div>

	</div>	
</template>

<script>

	export default {
		name: 'QueryButton',
		components:{},
		props:{
			activeQuery:{
				type:Object,
				required:false
			},
			deleteEnable:{
				type:Boolean,
				required: false,
				default: null
			},
			disable:{
				type:Boolean,
				required: false
			},
			enableDropDown:{
				type:Boolean,
				required:true
			},
			queries:{
				type: Array,
				required: false,
			},
			queryMode:{
				type:Number,
				required:false
			},
			staleFilters:{
				type:Boolean,
				required:false
			}
		},
		data()
			{return {
				drop: true,
				// applyFilters: true,
				btnConfig: [
					{sym:'R', code:'R'},  // remove
				]
			}	
		},
		methods:{
			querySelect(query){
				// console.log('querySelect -', query , this.queryMode)
				this.$emit('querySelect',{rootNod:this.rootNod,query:query, Op:this.queryMode})
				this.drop = false
			},
		},
		computed:{
			rootNod (){
				return this.queries[0].iBranches[0].Branch.Parent
			},
			buttonText (){
				if(this.enableDropDown){
					const queryText = this.queries[0].iBranches[0].Branch.Parent.name
					const buttonText = this.deleteEnable?queryText + '-R':queryText
					return buttonText
				}else{
					return null
				}
			},
			suffix(){
				const suffixString = this.deleteEnable?'-R':''
				return suffixString
			},
		}
	}
</script>

<style scoped>

	.query-button-component {
		display:flex;
	}
	.drop-div{
		display: inline-flex; /* constrain hover to this button */
		flex-direction: column;
		position: relative;
	}
	.row-div{
		display: flex;
		flex-direction: row;
	}
	.drop-list{
		background-color: #85c3b7;
		border-radius: 4px;
		margin-left: 5px;
		padding: 2px;
		display:none;
		flex-direction: column;
		z-index: 10;
		position: absolute;
		top: 100%;
		left: 0;
	}

	/* Only open the direct child list of the hovered parent */

	.drop-div:hover > .drop-list,
	.drop-list.show {
		display: flex;
	}		

	.button {
		align-items: center;
		display: flex;
		justify-content: center;
		height: 24px;
		min-width: 17px;
		border: 1px solid black;
		border-radius: 4px;
		margin-left: 1px;
		margin-right: 1px;
		width:fit-content;
		padding: 2px;
	}


	.noHover{
		pointer-events: none;
	}
	
	@media (hover: hover) {
	.button:hover{
			background-color: #a6f4e5;
	}
	}

	.selected{
		background-color: #42f545;
		font-weight: bold;
	}

	.stale{
		background-color: #edd5d3;
		font-weight: bold;
	}

</style>

